export const goBack = () => window.history.back();

export const navigateTo = (path: string) => (window.location.href = path);

export const getUrlParam = (param: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};
